/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notifications-container{width:150px;position:relative;background:0 0;margin:3px}.notification{width:150px;border-radius:3px;padding:3px;box-shadow:0 4px 8px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19);right:-150px;-webkit-animation:.5s forwards slide;animation:.5s forwards slide}@-webkit-keyframes slide{100%{right:0}}@keyframes slide{100%{right:0}}button.alert-close{right:1px;top:1px;margin-left:5px}"];
export { styles as styles };
